export enum SubtleAlertType {
    success = 'success',
    warning = 'warning',
    error = 'error',
}
